/*
 * @Author: hasee
 * @Date:   2016-11-11 14:56:06
 * @Last Modified by:   hasee
 * @Last Modified time: 2016-12-15 14:24:42
 */

// Vuex
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import APIS from './apis.js'
import router from './router.js'
import data from './data.js'
import qs from 'qs';

Vue.use(Vuex);
// const APIS = {
//     'isTested': '/animal/isTested',                     //判断是否做过题目
//     'questions': '/animal/lists',                           //拉取题目
//     'funreport': '/animal/create',                      //提交报告
//     'unlockReport': '/animal/reportRelease',  //解锁报告
//     'sharereport': '/animal/shareReport',           //获取分享报告
//     'getSelfReport': '/animal/getSelfReport',   //获取自己的趣味报告
//     'wechatData': '/common/getWeixinData',      //微信用户信息
//     'shouquan': '/common/authorization.html',   //微信授权
//     'tagclick': '/animal/tagclick',                     //点击标签
//     'proreport': '/animal/getReport',                   //获取专业报告
//     'friends': '/animal/friendReport',              //获取好友列表
//     'pay': '/freeTestOrder/payorder.html'           //获取订单信息
// }

let shouquan = function () {
    window.location.href = APIS.shouquan + '?callback=' + location.href;
};
axios.defaults.withCredentials = true;


const store = new Vuex.Store({
    state: {
        busy: false,
        stayFun: true,
        channel_id:1,
        sex: '1', // 1男、2女
        isTested: undefined,
        curQuestion: 1,
        questions: {},
        questionListLength: 0,
        answers: {},
        shareLock: 1,
        userInfo: {},
        price: 0,
        selfResult: null,
        funreport: null,
        sharereport: null,
        friendList: [],
        shareFrom: null,
        finishTest: false
    },
    mutations: {
        setSex(state, sex) {
            state.sex = sex
        },
        setStayFun(state, tof) {
            state.stayFun = tof;
        },
        setChannelId(state, channel_id) {
            state.channel_id = channel_id;
        },
        setCurQuestion(state, questionIndex) {
            state.curQuestion = questionIndex;
        },
        setAnswer(state, answer) {
            state.answer[state.curQuestion] = answer;
        },
        setQuestions(state, questions) {
            state.questions = questions;
        },
        setAnswers(state, answer) {
            state.answers[answer.key] = answer.value;
            state.questions[state.curQuestion].selected = answer.value;
        },
        setQuestionListLength(state, length) {
            state.questionListLength = length;
        },
        setIstested(state, isTested) {
            state.isTested = isTested;
        },
        setFunreport(state, payload) {
            state.selfResult = payload.report;
        	// state.selfResult.unlock = 0;
            let type = payload.report.result_type ==""?'scmp':payload.report.result_type;
            state.funreport = data[type][payload.report.gender];
            // state.funreport = data['pc'][payload.report.gender];
        },
        setFinishTest(state, tof) {
            state.finishTest = tof;
        },
        setBusy(state, tof) {
            state.busy = tof;
        },
        setshareLock(state) {
            state.selfResult.unlock = 1;
        },
        setUnlockPeople(state) {
            if(state.selfResult) {
                state.selfResult.unlock_num = state.selfResult.unlock_num*1+1;
            }
        },
        setShareReport(state, payload) {
            state.selfResult = payload.report;
            state.sharereport = data[payload.report.result_type][payload.report.gender];
        },
        setFriendList(state, payload) {
            state.friendList = payload;
        },
        emptyReport(state) {
            state.selfResult = null;
            state.funreport = null;
            state.sharereport = null;
            state.finishTest = false;
            state.curQuestion = 1;
        },
        setShareFrom(state, fromId) {
            state.shareFrom = fromId;
        }
    },
    actions: {
        pullQuestion(context, getObjLength) {
            // 异步拉去题目数据
            context.commit('setBusy', true);
            axios.get(APIS.questions, {
                params: {
                    // free_test_id: 11
                }
            }).then(function(res) {
                context.commit('setBusy', false);
                if (res.data.code == 200) {
                    context.commit('setQuestions', res.data.data);
                    context.commit('setQuestionListLength', getObjLength(res.data.data));
                } else if (res.data.code == 1001){
                    //拿授权
                    shouquan()
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        pullIstested(context, getObjLength) {
            // 异步拉取是否做过题目
            context.commit('setBusy', true);
            axios.get(APIS.isTested).then(function(res) {
                context.commit('setBusy', false);
                if (res.data.code == 200) {
                    context.commit('setIstested', res.data.data.is_tested);
                } else if (res.data.code == 1001){
                    //拿授权
                    shouquan()
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        createFunReport(context, data) {
    		let longEnough = data.check(data.dataPack.params);
            let postData = {
                gender: data.dataPack.gender,
                data: JSON.stringify(data.dataPack.params)
            }
            if( (context.state.shareFrom != null) & (context.state.shareFrom != undefined) & (context.state.shareFrom != '') ) {
                postData.activate_id = context.state.shareFrom;
            }
        	if(longEnough != data.questionListLength) {
        		return false;
        	}
            context.commit('setBusy', true);
            axios.post(APIS.funreport, qs.stringify(postData)).then(function(res) {
                context.commit('setBusy', false);
                if (res.data.code == 200) {
                    context.dispatch('getSelfReport', {
                        callback: data.callback
                    })
                } else if (res.data.code == 1001){
                    //拿授权
                    shouquan()
                } else {
                	console.log('创建报告失败');
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        getSelfReport(context, payload) {
            axios.get(APIS.getSelfReport).then(function(res) {
                if(res.data.code == 200) {
                    context.commit('setFunreport', {
                        report:res.data.data,
                    });
                    context.dispatch('getFriendList', res.data.data.activate_id)
                    if( (payload.callback != undefined) & (typeof(payload.callback)=='function') ) {
                        payload.callback();
                    }
                } else if (res.data.code == 1001){
                    //拿授权
                    shouquan()
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        getFriendList(context, payload) {
            context.commit('setBusy', true);
            axios.get(APIS.friends, {
                params: {
                    id: payload
                }
            }).then(function(res) {
                context.commit('setBusy', false);
                if(res.data.code == 200) {
                    context.commit('setFriendList', res.data.data);
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        unLockPeopleAdd(context, id) {
            context.commit('setBusy', true);
            axios.get(APIS.unlockPeople, {
                params: {
                    id: id?id:'11'
                }
            }).then(function(res) {
                context.commit('setBusy', false);
                if(res.data.code == 200) {
                    context.commit('setUnlockPeople');
                }
            }).catch(function(error) {
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        buyProReport(context, payload) {
            context.commit('setBusy', true);
            location.href = `${APIS.buyProReport}?test_id=${payload.test_id?payload.test_id:11}&channel_id=${payload.channel_id? payload.channel_id:1}`
            // axios.get(APIS.buyProReport, {
            //     params:{
            //         test_id: payload.test_id?payload.test_id:11,
            //         channel_id: payload.channel_id? payload.channel_id:1
            //     }
            // }).then(function(res) {
            //     context.commit('setBusy', false);
            //     if(res.data.code == 200) {
            //         location.href = res.data.data.pay_url +
            //         '?order_id=' + res.data.data.order_id +
            //         '&redirect_url=' + encodeURIComponent('http://static.xinli001.com/animalPicture/index.html#/funreport') +
            //         '&success_url=' + encodeURIComponent('http://static.xinli001.com/animalPicture/index.html#/proreport') ;
            //     } else if (res.data.code == 1001){
            //         //拿授权
            //         shouquan()
            //     }
            // }).catch(function(error) {
            //     context.commit('setBusy', false);
            //     console.log(error);
            // })
        },
        unLockReport(context, id) {
            context.commit('setBusy', true);
            axios.get(APIS.unlockReport, {
                params: {
                    id:id
                }
            }).then(function(res){
                context.commit('setBusy', false);
                if(res.data.code == 200) {
                    context.commit('setshareLock');
                }
                context.dispatch('getFriendList', id);
            }).catch(function(error){
                context.commit('setBusy', false);
                console.log(error);
            })
        },
        pullShareInfo(context, data) {
            context.commit('setBusy', true);
            axios.get(APIS.sharereport, {
                params:{
                    id:data.id
                }
            }).then(function(res){
                context.commit('setBusy', true);
                if(res.data.code == 200) {
                    context.commit('setShareReport', {
                        report: res.data.data,
                        gender: data.gender
                    });
                }
            }).catch(function(error) {
                context.commit('setBusy', true);
                console.log(error);
            })
        }
    }
});

export default store



// WEBPACK FOOTER //
// ./src/store.js